import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, Wine } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center text-primary">
              <Wine size={18} strokeWidth={1.5} />
            </span>
            <span className="font-display text-2xl">Pinkies Up</span>
          </div>
          <p className="mt-6 text-muted-foreground max-w-md leading-relaxed">
            A mobile cocktail experience for weddings, private parties, and
            unforgettable evenings. Elegant service. Bold flavours. A little
            pink.
          </p>
        </div>
        <div>
          <div className="overline text-primary/70">Explore</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/packages" className="hover:text-primary transition-colors">Packages</Link></li>
            <li><Link to="/gallery" className="hover:text-primary transition-colors">Gallery</Link></li>
            <li><Link to="/book" className="hover:text-primary transition-colors">Book an event</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-primary transition-colors">Admin</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-primary/70">Connect</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2 text-muted-foreground"><Mail size={14}/> pinkiesupcocktailbar@gmail.com</li>
            <li className="flex items-center gap-2 text-muted-foreground"><Phone size={14}/> +1 (555) 555-0132</li>
            <li className="flex items-center gap-2 text-muted-foreground"><Instagram size={14}/> @Pinkie.Up.Cocktails</li>
          </ul>
        </div>
      </div>
      <div className="hairline">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>&copy; {new Date().getFullYear()} Pinkies Up. All rights reserved.</div>
          <div className="tracking-widest uppercase">Crafted with cocktails</div>
        </div>
      </div>
    </footer>
  );
}
